import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class PasswordValidator {
  public static StrongPassword: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    const value = control.value.toString();

    if (!/[A-Z]/.test(value)) {
      return { uppercase: 'libs.validation.password.uppercase' };
    }

    if (!/[a-z]/.test(value)) {
      return { lowercase: 'libs.validation.password.lowercase' };
    }

    if (!/\d/.test(value)) {
      return { digit: 'libs.validation.password.digit' };
    }

    if (!/[!#*$%&?@]/.test(value)) {
      return { specialChar: 'libs.validation.password.special-char' };
    }

    if (/\s/.test(value)) {
      return { noWhitespace: 'libs.validation.password.no-whitespace' };
    }

    if (/[^A-Za-z\d!#*$%&?@]/.test(value)) {
      return { invalidChar: 'libs.validation.password.invalid-char' };
    }

    return null;
  };
}
